import React, { Component } from 'react';

import cn from 'client/utils/cn';

import './index.css';

const b = cn('link');

interface Props {
    text?: string;
    href?: string;
    target?: '_blank' | undefined;
    color?: 'blue' | undefined;
    children?: React.ReactElement | React.ReactElement[];
}

export default class Link extends Component<Props> {
    renderLinkContent = (): React.ReactNode => {
        const { text, children } = this.props;

        return (
            <>
                {text || children}
            </>
        );
    }

    render(): React.ReactNode {
        const { href, target, color } = this.props;

        if (!href) {
            return null;
        }

        return (
            <a href={href} target={target} className={b({ color })}>
                {this.renderLinkContent()}
            </a>
        );
    }
}
